import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { BusinessRole } from '../../../models/role.model';
import { selectHasBusinessRole, selectRolesLoaded } from '../../../store/selectors/pd.selectors';
import { RoutesName } from '../constants/routes-name';
import { combineLatest } from 'rxjs/internal/observable/combineLatest';

export const performanceAdminGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const isPerformanceAdmin$ = store.select(selectHasBusinessRole(BusinessRole.PerformanceAdmin));
  const isUtilityDispatchUser$ = store.select(selectHasBusinessRole(BusinessRole.UtilityDispatchUser));

  return store.select(selectRolesLoaded).pipe(
    filter(loaded => loaded),
    take(1),
    switchMap(() => combineLatest([isPerformanceAdmin$, isUtilityDispatchUser$]).pipe(
      take(1),
      map(([isAdmin, isDispatchUser]) => isAdmin || isDispatchUser)
    )),
    map(isProgramUser => (isProgramUser ? true : router.createUrlTree([RoutesName.ROOT])))
  );
};
